import { CarouselProps } from '@design-system/carousel';
import { ReactNode } from 'react';

import { buttonMapper } from '~/mappers/button';

import { Carousel, FillLivePlaceholderModel } from './models';

const fillLivePlaceholder = (
  ariaLivePlaceholder: string,
  map: FillLivePlaceholderModel
) => {
  let result = ariaLivePlaceholder;

  Object.entries(map).forEach(([before, after]) => {
    result = result.replace(`{${before}}`, after.toString());
  });

  return result;
};

export const carouselMapper = <T = CarouselProps>(
  {
    ui: {
      className,
      buttonNext,
      buttonPrevious,
      gap,
      preferredCardSize,
      progressIndicator,
      variant,
      ariaLivePlaceholder,
      numbered,
      centerInsufficientSlides,
    },
  }: Carousel,
  items?: ReactNode[]
): T =>
  ({
    className,
    buttonNext: buttonMapper(buttonNext),
    buttonPrev: buttonMapper(buttonPrevious),
    variant,
    progressIndicator,
    ariaLivePlaceholder: (
      index: number,
      total: number,
      slidesPerView: number,
      progress: number
    ) =>
      fillLivePlaceholder(ariaLivePlaceholder, {
        index,
        total,
        slidesPerView,
        progress,
      }),
    ...(items && { items: items.map((children) => ({ children })) }),
    ...(gap !== null && { gap }),
    ...(preferredCardSize && { preferredCardSize }),
    ...(numbered && { wrapperTag: 'ol' }),
    ...(centerInsufficientSlides !== null && { centerInsufficientSlides }),
  } as T);
